
import HelpText from '@marketplace/components/forms/inputs/shared/help-text.vue'
import InputLabel from '@marketplace/components/forms/inputs/shared/input-label.vue'
import InvalidFeedback from '@marketplace/components/forms/inputs/shared/invalid-feedback.vue'

export default {
    name: 'TextInput',

    components: {
        InputLabel,
        InvalidFeedback,
        HelpText,
    },

    inheritAttrs: false,

    props: {
        id: {
            type: String,

            /**
             * Set a default id for the text input.
             *
             * @returns {string}
             */
            default() {
                // the `this._uid` is a Vue variable.
                // eslint-disable-next-line
                return `text-input-${this._uid}`
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        value: {
            type: [String, Number],
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        errorMsg: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        optional: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: '',
        },
        textInTitle: {
            type: Boolean,
            default: false,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        isValid: {
            type: Boolean,
            default: false,
        },
        showStatusIcons: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        inputClass: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            passwordIsShown: false,
        }
    },

    computed: {
        /**
         * Determines the input class based on the current state.
         *
         * @returns {string}
         */
        validityClass() {
            return {
                'border-danger focus:border-danger': this.isInvalid,
                'border-grey-400 focus:border-black':
                    (!this.isValid && !this.isInvalid) ||
                    (this.isValid && !this.isInvalid),
                'pr-6': this.showStatusIcons && this.type !== 'password',
                'pr-12': this.showStatusIcons && this.type === 'password',
                'pl-6': this.hasInlineAddon,
            }
        },
        hasInlineAddon() {
            return Boolean(this.$slots['inline-addon'])
        },
        passwordFieldType() {
            return this.passwordIsShown ? 'text' : 'password'
        },
        displayedInputType() {
            return this.type === 'password' ? this.passwordFieldType : this.type
        },
    },

    methods: {
        /**
         * Focuses the input.
         */
        focus() {
            this.$refs.input.focus()
        },
        togglePasswordFieldType() {
            this.passwordIsShown = !this.passwordIsShown
        },
    },
}
